import img1 from '../assets/img/result/1.png'
import img2 from '../assets/img/result/2.png'
import img3 from '../assets/img/result/3.png'
import img4 from '../assets/img/result/4.png'
import img5 from '../assets/img/result/5.png'
import img6 from '../assets/img/result/6.png'
import img7 from '../assets/img/result/7.png'
import img8 from '../assets/img/result/8.png'
import img9 from '../assets/img/result/9.png'
import img10 from '../assets/img/result/10.png'
// import img11 from '../assets/img/result/11.png'
// import img12 from '../assets/img/result/12.png'
export default[
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  // img11,
  // img12
]



// WEBPACK FOOTER //
// ./src/utils/image.js